import Vue from 'vue'
import VueRouter from 'vue-router'
import _this from '@/main.js'
import { getToken } from '@/utils/auth';
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/order'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import(/* webpackChunkName: "order" */ '@/views/order')
  },
  {
    path: '/goods',
    name: 'goods',
    component: () => import(/* webpackChunkName: "goods" */ '@/views/goods')
  },
  {
    path: '/cardPassword',
    name: 'cardPassword',
    component: () => import(/* webpackChunkName: "cardPassword" */ '@/views/cardPassword')
  },
  {
    path: '/classify',
    name: 'classify',
    component: () => import(/* webpackChunkName: "classify" */ '@/views/classify')
  },
  {
    path: '/userList',
    name: 'userList',
    component: () => import(/* webpackChunkName: "userList" */ '@/views/userList')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "notFound" */ '@/views/notFound')
  }
]

function hasPermission(to, permissions) {
  return permissions.includes(to.name);
}

// 定义一个函数来找到用户有权访问的下一个路由（这里只是简单示例，你可以根据实际需求调整）  
function getNextAllowedRoute(permissions, routes) {
  // 遍历所有路由，找到用户有权访问的第一个路由  
  for (const route of routes) {
    if (hasPermission({ name: route.name }, permissions)) {
      return route.path; // 返回路由的路径（或你可以返回其他标识符）  
    }
  }
  
  // 如果没有找到任何有权访问的路由，则返回默认页面的路径  
  return '/noPage';
}

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})


router.beforeEach(async (to, from, next) => {

  if (!getToken() && to.path !== '/login')
    return next('/login');

  if (getToken() && to.path === '/login')
    return next('/');

  if (getToken() && !store.state.userInfo)
    await store.dispatch('getUser')

  if (getToken()) {
    if (store.state.userInfo.objectName === '*' || to.path === '/noPage') return next();
    let userPermissions = store.state.userInfo.objectName.split(',')

    if (hasPermission(to, userPermissions)) {
      // 用户有权访问该路由  
      next();
    } else {
      // 用户无权访问该路由，找到下一个允许访问的路由或重定向到默认页面  
      const nextRoute = getNextAllowedRoute(userPermissions, routes);
      next(`${nextRoute}`);
    }
  }


  next();


  // if ( to.path === '/userList' && store.state.userInfo.id !== '0') {
  //     next(from.path)


  //     let userNav = store.state.userInfo.objectName.split(',')

  //     const match = userNav.find(elem => nav.includes(elem));  
  //     console.log(match);
  //   }

})

export default router
